import {AxiosPromise} from 'axios';
import {apiCaller} from '@/api/apiCaller';
import {apihost} from '@/api/urls';
import {Brand} from '@/modules/neovehicle/models';
import { CountryEnum } from '@/models/Enums';

const getBrandWithContract = (filter: { idVehicleTypes: number[], country: CountryEnum }): AxiosPromise<Brand[]> =>
  apiCaller.getParams(`/neovehicle/contracts/brands`, apihost, filter);

const getBrands = (): AxiosPromise<Brand[]> =>
  apiCaller.get(`/neovehicle/brands`, apihost);

export const brandService = {
  getBrandWithContract,
  getBrands,
};
